export default "__VITE_ASSET__D3a7uANj__"